import { gql, QueryResult, useQuery } from "@apollo/client";

import { CategoryQuery, GetCategoriesQuery } from "../../generated/gql/graphql";

const GET_CATEGORIES = gql`
  query GetCategories {
    categories {
      items {
        id
        name
        parentId
        orderIndex
      }
    }
  }
`;

export default function useCategories(
  query?: CategoryQuery
): QueryResult<GetCategoriesQuery> {
  return useQuery(GET_CATEGORIES, {
    variables: {
      query,
    },
  });
}
